// extracted by mini-css-extract-plugin
module.exports = {"l-global-header":"_l-header_l-global-header___hwIX","js-window-page":"_l-header_js-window-page__UdGGi"};